import { createAction, props } from "@ngrx/store";

const prefix = "[Role Search Bar]";

export const addRoleToSearch = createAction(
  `${prefix} Add Role To Search`,
  props<{ role: string }>(),
);
export const removeRoleFromSearch = createAction(
  `${prefix} Remove Role From Search`,
  props<{ role: string }>(),
);
